import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useStepsStore } from "./state";
import { emptyYachtForm, YachtForm } from "./yacht.schema";
import { Form } from "@/src/components/ui/form";
import { BasicDetails } from "./BasicDetails";
import { LocationAndPricing } from "./LocationAndPricing";
import { Specification } from "./Specification";
import { Amenities } from "./Amenities";
import { Summary } from "./Summary";
import { useSubscribe } from "@/src/lib/actions";
import { useCallback } from "react";
import { toast } from "@/src/components/ui/use-toast";

export type EditYachtFormProps = {
  yacht?: YachtForm;
  onSubmit?: (yacht: YachtForm) => void;
};
export function EditYachtForm({ yacht, onSubmit: _onSubmit }: EditYachtFormProps) {
  const { step, setStep } = useStepsStore();
  const form = useForm<YachtForm>({
    resolver: zodResolver(YachtForm),
    defaultValues: yacht ?? emptyYachtForm,
    mode: "onTouched",
    reValidateMode: "onChange",
  });

  (window as any)["getValue"] = () => console.log(form.getValues(), form);

  const onSubmit = useCallback(
    form.handleSubmit(
      (data) => {
        _onSubmit?.(data);
      },
      (errors) => {
        console.error("FORM ERROR", errors);
        if (errors) {
          toast({
            title: "Failed to edit yacht",
            description: "The form is missing required fields",
            variant: "destructive",
          });

          setStep(
            (errors.basicDetails || errors.meta) &&
              !errors.specification &&
              !errors.locationAndPricing &&
              !errors.amenities
              ? "Basic details"
              : !errors.basicDetails && errors.specification && !errors.locationAndPricing && !errors.amenities
                ? "Specification"
                : !errors.basicDetails && !errors.specification && errors.locationAndPricing && !errors.amenities
                  ? "Location & Pricing"
                  : !errors.basicDetails && !errors.specification && !errors.locationAndPricing && errors.amenities
                    ? "Amenities"
                    : "Basic details",
          );
        }
      },
    ),
    [form],
  );

  useSubscribe("yacht:save", onSubmit);

  return (
    <Form {...form}>
      <form className="flex flex-col gap-6" onSubmit={onSubmit}>
        {step === "Basic details" && <BasicDetails />}
        {step === "Location & Pricing" && <LocationAndPricing />}
        {step === "Specification" && <Specification />}
        {step === "Amenities" && <Amenities />}
        {step === "Summary" && <Summary />}
      </form>
    </Form>
  );
}
